import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {

/*-------------------------------------------------------------------------------
    共通・初期化
  --------------------------------------------------------------------------------*/
  pageLoading();
  modalImage();
  scrollEffect();

/*-------------------------------------------------------------------------------
  お問い合わせ用バリデーション
--------------------------------------------------------------------------------*/
// ページ内に #form-confirm という要素が存在する場合のみバリデーション実行
if (document.querySelector('#form-confirm')) {
  topValidation();
}

/*-------------------------------------------------------------------------------
  ハンバーガーナビゲーション
--------------------------------------------------------------------------------*/
const hamburger = document.querySelector('.menu-trigger');
const nav = document.querySelector('.nav');
// 要素が存在する場合のみ実行する
if (hamburger && nav) {
  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('js-open');
    nav.classList.toggle('js-open');
  });
}

/*-------------------------------------------------------------------------------
  アンカーリンクのスムーススクロール
--------------------------------------------------------------------------------*/
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    const hashIndex = href.indexOf('#');
    
    if (hashIndex === -1) return;
    
    const hash = href.substring(hashIndex);
    const path = href.substring(0, hashIndex);
    
    // 同じページ内またはページ遷移後のアンカーの場合
    if (hash && hash !== '#') {
      const targetId = hash.substring(1);
      const targetElement = document.getElementById(targetId);
      
      // 現在のページにターゲット要素がある場合のみスムーススクロール
      if (targetElement && (path === '' || path === window.location.pathname || path === window.location.pathname.replace(/\/$/, ''))) {
        e.preventDefault();
        
        const header = document.querySelector('.header.fixed_hd') || document.querySelector('.header');
        const headerHeight = header ? header.offsetHeight : 0;
        const offset = 20;
        
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        
        if (hamburger && nav) {
          hamburger.classList.remove('js-open');
          nav.classList.remove('js-open');
        }
      }
    }
  });
});

// ページ読み込み時のハッシュ処理
window.addEventListener('load', () => {
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      setTimeout(() => {
        const header = document.querySelector('.header.fixed_hd') || document.querySelector('.header');
        const headerHeight = header ? header.offsetHeight : 0;
        const offset = 20;
        
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
});

/*-------------------------------------------------------------------------------
  ヘッダーナビゲーション(トップページのみ)
--------------------------------------------------------------------------------*/

  // トップページのみ:メインビュー通過後に固定ヘッダーを上から降ろす
  const fixedHeader = document.querySelector('.fixed_hd');
  const mvContainer = document.querySelector('.mv_container');
  const sideHeader = document.querySelector('.side-hd');
  
  // トップページ判定(.side-hdが存在する場合)
  if (fixedHeader && mvContainer && sideHeader) {
    let mvHeight = mvContainer.offsetHeight;
    let ticking = false;
    
    // リサイズ時にMV高さを再計算
    const updateMvHeight = () => {
      mvHeight = mvContainer.offsetHeight;
    };
    
    window.addEventListener('resize', updateMvHeight);
    
    // スクロール処理(パフォーマンス最適化)
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // MV通過後にヘッダーを上から降ろす
      if (scrollTop > mvHeight) {
        fixedHeader.classList.remove('is-hidden');
      } else {
        fixedHeader.classList.add('is-hidden');
      }
      
      ticking = false;
    };
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    });
    
    // 初期状態チェック(ページ読み込み時にスクロール位置が途中の場合)
    handleScroll();
  }


/*-------------------------------------------------------------------------------
  Swiper スライダー
--------------------------------------------------------------------------------*/

if (document.querySelector('.movieSwiper')) {
  const swiper = new Swiper('.movieSwiper', {
    // レイアウト設定
    slidesPerView: 'auto', // CSSのwidth (20vw / 70vw) を有効にする
    centeredSlides: true,  // アクティブなスライドを中央に
    loop: true,            // 無限ループ
    
    // 自動再生（ゆっくり）
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 800,

    // ナビゲーション
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    
    // スクロールバー
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },

    // 余白設定（CSSのmargin-rightと数値を合わせる）
    // モバイルファースト記述
    spaceBetween: 20, // スマホ用 (CSS: margin-right: 20px)

    breakpoints: {
    768: {
        spaceBetween: 60, // PC用 (CSS: margin-right: 60px)
      }
    }
  });
}

/*-------------------------------------------------------------------------------
  FAQ アコーディオン
--------------------------------------------------------------------------------*/
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  if (faqQuestions.length > 0) {
  // スライドアップアニメーション
    const slideUp = (element, duration = 300) => {
      element.style.height = element.scrollHeight + 'px';
      element.style.transitionProperty = 'height, opacity, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.offsetHeight; // reflow
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      element.style.opacity = 0;
      
      setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('opacity');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
      }, duration);
    };
    
    // スライドダウンアニメーション
    const slideDown = (element, duration = 300) => {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'flex';
      element.style.display = display;
      
      const height = element.scrollHeight;
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      element.style.opacity = 0;
      element.offsetHeight; // reflow
      element.style.transitionProperty = 'height, opacity, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.style.height = height + 'px';
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.opacity = 1;
      
      setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
        element.style.removeProperty('opacity');
      }, duration);
    };
    
    faqQuestions.forEach(function(question) {
      question.addEventListener('click', function() {
        const answer = this.nextElementSibling;
        const isOpen = this.classList.contains('is-open');
        
        // 他のFAQを閉じる
        faqQuestions.forEach(function(otherQuestion) {
          if (otherQuestion !== question) {
            const otherAnswer = otherQuestion.nextElementSibling;
            if (otherQuestion.classList.contains('is-open')) {
              otherQuestion.classList.remove('is-open');
              if (otherAnswer && otherAnswer.classList.contains('faq-answer')) {
                slideUp(otherAnswer, 300);
              }
            }
          }
        });
        
        // クリックされたFAQを開閉
        if (answer && answer.classList.contains('faq-answer')) {
          if (isOpen) {
            this.classList.remove('is-open');
            slideUp(answer, 300);
          } else {
            this.classList.add('is-open');
            slideDown(answer, 300);
          }
        }
      });
    });
  }
});



